import { useMutation } from '@tanstack/react-query'
import { requestUpgrade } from '@/api/subscriptionsAPI'
import type { UUID } from 'crypto'

export function useRequestUpgrade() {
  return useMutation({
    mutationFn: ({ orgUuid, token }: { orgUuid: UUID; token: string }) =>
      requestUpgrade(orgUuid, token),
  })
}
